import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { EtfTransaction } from "../repositories/goldEtfRepository";

export type GoldEtfStateData = {
    id: string; // customerId
    transactions: EtfTransaction[];
};

const initialState: GoldEtfStateData[] = [];

const goldEtfSlice = createSlice({
    name: 'goldEtf',
    initialState,
    reducers: {
        setGoldEtfs(state, action: PayloadAction<GoldEtfStateData[]>) {
            return action.payload;
        },
        addGoldEtf(state, action: PayloadAction<GoldEtfStateData>) {
            state.push(action.payload);
        },
        resetGoldEtf() {
            return initialState;
        }
    }
});

export const { setGoldEtfs, addGoldEtf, resetGoldEtf } = goldEtfSlice.actions;
export default goldEtfSlice.reducer;
